export default {
      id: "toolbox-outline-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#toolbox-outline-usage",
      toString: function () {
        return this.url;
      }
    }